<template>
  <input
    ref="inputRef"
    v-model="formattedValue"
    :class="inputClass"
    :placeholder="placeholder"
    type="text"
    @click.stop
  />
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useCurrencyInput } from 'vue-currency-input';

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: null,
  },
  options: {
    type: Object,
    default: () => ({
      locale: 'de-DE',
      currency: 'EUR',
      currencyDisplay: 'symbol' as const,
      precision: 2,
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false,
      autoDecimalDigits: false,
      exportValueAsInteger: false,
      autoSign: true,
      useGrouping: true,
      separator: '.',
      decimal: ',',
    }),
  },
  placeholder: {
    type: String,
    default: '',
  },
  inputClass: {
    type: String,
    default:
      'tw-w-full tw-font-normal tw-px-3 tw-py-2 tw-text-sm tw-border tw-border-gray-300 tw-rounded-md tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-secondary-300 tw-focus:border-secondary-300 tw-transition-colors',
  },
});

const emit = defineEmits<{
  'update:modelValue': [value: number | null];
  change: [value: number | null];
}>();

const { inputRef, formattedValue, setValue, setOptions } = useCurrencyInput(props.options as any);

watch(
  () => props.modelValue,
  (value: any) => {
    setValue(value);
  }
);

watch(
  () => props.options,
  (options: any) => {
    setOptions(options);
  }
);
</script>
